import { createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../../api/services/user";

export const getAdminUserInfo = createAsyncThunk(
  "user/getAdminUserInfo",
  async () => {
    return await userService.getAdminUserInfo();
  }
);

export const getAvailablePackages = createAsyncThunk(
  "user/getAvailablePackages",
  async () => {
    return await userService.getAvailablePackages();
  }
);

export const updateSubscriptionPackage = createAsyncThunk(
  "user/updateSubscriptionPackage",
  async (subscriptionPackage) => {
    return await userService.updateSubscriptionPackage(subscriptionPackage);
  }
);

export const changePassword = createAsyncThunk(
  "passwordChange/changePassword",
  async (requestData) => {
    return await userService.changePassword(requestData);
  }
);
